import { createSingleEntityStore, ngrxEvent } from '@recruitee/ngrx';

import { EntityStoreKey } from '../../types';
import { CurrentUserPreferencesRequestData } from './current-user-preferences.types';

const LS_KEY = 'recruitee-theme';
const DEFAULT_THEME = 'light';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<CurrentUserPreferencesRequestData | null>()(
    EntityStoreKey.userPreferences,
    {
      initialState: {
        data: { preferences: { theme: localStorage.getItem(LS_KEY) || DEFAULT_THEME } },
        loaded: false,
        pending: false,
        failed: false,
        error: null,
      },
      customActions: adapter => ({
        updatePreferredTheme: ngrxEvent<'light' | 'dark' | 'auto'>(),
      }),
    },
  );

export {
  actions as CurrentUserPreferencesActions,
  selectors as CurrentUserPreferencesSelectors,
  reducer as CurrentUserPreferencesReducer,
  namespace as CurrentUserPreferencesNamespace,
};
